import React from 'react';
import {useTranslation} from 'react-i18next';
import {Card, CardBody, Col} from 'reactstrap';
import {LocaleLink} from '@/routes';
import Separator from '@/views/shared/Separator';
import styles from '@/views/ForgetPassword/index.module.css';

const ResetSuccuss = ({loginId}) => {
  const {t: tr} = useTranslation('forget_password');
  const subtr = tr('reset_success');

  return (
    <Card>
      <CardBody className={styles.section}>
        <div className='text-center'>
          <br />
          <h1 className={styles.title}>{tr('title')}</h1>
          <Separator />
          <h3 className={styles.subtitle}> {subtr.sub_title} </h3>
          <br />
          <br />
          <span>{subtr.content_line1}</span>
          <br />
          <span>{tr('reset_success.content_line2', {loginId})}</span>
          <br />
          <br />
          <Col md={{size: 6, offset: 3}}>
            <LocaleLink
              to='/login'
              className='btn btn-secondary btn-lg btn-block'
            >
              {tr('go_to_login')}
            </LocaleLink>
          </Col>
        </div>
      </CardBody>
    </Card>
  );
};

export default ResetSuccuss;
